class TradeInSidebar extends HTMLElement {
    constructor() {
        super();

        // OPEN
        document.querySelectorAll("[data-open-tradein-sidebar]")
            .forEach(btn => btn.addEventListener("click", this.openSidebar.bind(this)));

        // CLOSE
        document.querySelector("[data-close-tradein-sidebar]") &&
            document.querySelector("[data-close-tradein-sidebar]")
            .addEventListener("click", this.closeSidebar.bind(this));

        // CLOSE ON OUTSIDE CLICK
        document.body.addEventListener("click", this.onBodyClick.bind(this));
    }

    openSidebar(event) {
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.add("tradein-sidebar-show");
    }

    closeSidebar(event) {
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove("tradein-sidebar-show");
    }

onBodyClick(event) {
    const sidebarOpen = document.body.classList.contains("tradein-sidebar-show");

    if (!sidebarOpen) return;

    const sidebar = document.querySelector("[data-tradein-sidebar]");
    const clickedInsideSidebar = sidebar.contains(event.target);
    const clickedTrigger = event.target.closest("[data-open-tradein-sidebar]");
    const clickedOverlay = event.target.classList.contains("background-overlay");

    if (!clickedInsideSidebar && !clickedTrigger || clickedOverlay) {
        this.closeSidebar(event);
    }
}
}

customElements.define("tradein-sidebar", TradeInSidebar);